import requestMaker from 'lib';

export const fetchUserDetailsAPI = () => {
  const baseQuery = `/proxy/prv/ps/gup`;
  return requestMaker(baseQuery);
};
